/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable default-case */
import React, { useState } from 'react';
import { fetchConToken } from 'helpers/fetch';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';

const AsignarPreciosArticulo = ({ id, GetSucursalId, articulo, setArticulo, listaPrecios, setReload, precioArticulo, closeModal }) => {
    const { t } = useTranslation('common');
    let [_listaPrecios, setListaPrecios] = useState(listaPrecios || []);
    let [nuevoPrecioArticulo, setNuevoPrecioArticulo] = useState({
        id: 0,
        articulo_Id: id,
        lista_Precio_Id: 0,
        precio: 0
    });

    function getListasPrecios() {
        fetchConToken(`ListaPrecios/List?sucursal_Id=${GetSucursalId}`).then((response) => setListaPrecios(response));
    }

    function handleChangePrecios(e) {
        setNuevoPrecioArticulo({
            ...nuevoPrecioArticulo,
            [e.target.name]: e.target.value
        });
    }

    const agregarPrecio = () => {
        if (String(nuevoPrecioArticulo.lista_Precio_Id) === '0') {
            Swal.fire('', 'Seleccione una lista de precio', 'info');
            return;
        }

        if (nuevoPrecioArticulo.precio < 1) {
            Swal.fire('', 'Escriba un precio valido', 'info');
            return;
        }

        fetchConToken(`PrecioArticulo`, nuevoPrecioArticulo, 'POST').then(function (response) {
            if (response.hasOwnProperty('status')) {
                Object.entries(response.errors).forEach(([, value]) => {
                    Swal.fire('Error', value[0], 'error');

                });
                return false;
            } else if (response.hasOwnProperty('codigo') && response.codigo !== 200) {
                Swal.fire('Error', response.mensajes[0], 'error');
                return false;
            }

            if (_listaPrecios.filter(x => String(x.id) === String(nuevoPrecioArticulo.lista_Precio_Id) && x.es_Principal).length > 0) setArticulo({
                ...articulo,
                precio_Base: nuevoPrecioArticulo.precio,
                costo_Unidad: nuevoPrecioArticulo.precio
            });

            Swal.fire(t('app.SwalFire.exitoso'), 'Precio agregado', 'success');
            if (precioArticulo) precioArticulo(id);

            if (setReload) {
                setReload(true);
                setReload(false);
            }

            if (closeModal) closeModal();
        });
    };

    React.useEffect(() => {
        if (!(listaPrecios && listaPrecios.length > 0)) getListasPrecios();
    }, [articulo]);

    return (<div className='card text-left' style={{ padding: 10 }}>
        <div className='col-md-12 row'>
            <div className='col-sm-10'>
                <div className='card-body text-start'>
                    <label htmlFor='impuesto' className='form-label title2'>Agregar Precio</label>
                    <div className='row'>
                        <div className='col-md-6'>
                            <select
                                className='form-select'
                                onChange={handleChangePrecios}
                                name='lista_Precio_Id'
                            >
                                <option key={0} value='0'>Seleccione el precio</option>
                                {_listaPrecios?.map((item) => (<option key={item.id} value={item.id}>{item.nombre}</option>))}
                            </select>
                        </div>
                        <div className='col-md-6'>
                            <input
                                type='number'
                                className='form-control'
                                name='precio'
                                onChange={handleChangePrecios}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className='col-sm-2'>
                <div className='espacio30px' />
                <button
                    type='button'
                    className='btn btn-outline-primary'
                    onClick={(e) => agregarPrecio()}
                >
                    <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='20'
                        height='20'
                        fill='currentColor'
                        className='bi bi-check-lg'
                        viewBox='0 0 16 16'
                    >
                        <path d='M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z' />
                    </svg>
                    &nbsp;Asignar
                </button>
            </div>
        </div>
    </div>);
}

export { AsignarPreciosArticulo };